
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CardBody from '@/components/card-body/index.vue'
import Barcode from '@/entities/barcode'
import User from '@/entities/user'
import dayjs from 'dayjs'

@Component({
  components: { CardBody }
})
export default class BarcodeDetailEdit extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'Barcode Edit'

  barcode: Barcode = new Barcode()

  rules = {
    barcodeId: [
      {
        required: true,
        message: 'Please input Barcode ID',
        trigger: 'blur'
      }
    ],
    partNo: [
      {
        required: true,
        message: 'Please input Part Number',
        trigger: 'blur'
      }
    ],
    qty: [
      {
        required: true,
        message: 'Please input quantity of pack',
        trigger: 'change'
      }
    ]
  }

  // 新建或更新
  doCreateOrUpdate() {
    ;(this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      this.createOrUpdateBarcode({
        barcode: this.barcode
      })
    })
  }
  // 调用接口
  async createOrUpdateBarcode(data) {
    await this.$store.dispatch({
      type: 'barcode/createOrUpdateBarcode',
      data: data
    })
    this.$notify.success({
      title: 'Success',
      message: 'Save Success'
    })
    this.doCancel()
  }

  doCancel() {
    ;(this.$refs.form as any).resetFields()
    this.$router.back()
  }

  loading = false

  async created() {
    try {
      this.loading = true
      let id = +this.$route.params.id
      if (!id || id < 0) {
        // 新增
        return
      }
      // 编辑
      this.barcode.id = +id
      let res = await this.$store.dispatch({
        type: 'barcode/get',
        id: this.$route.params.id
      })
      this.barcode = res.barcode
    } catch (e) {
      console.log(e);
    } finally{
      this.loading = false
    }
  }
}
